import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchAnomalySoofieTimeseries } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const AnomalySoofieTimeseriesChartSlice: Slice<any, {}, "AnomalySoofieTimeseriesChartSlice"> = createSlice({
    name: "AnomalySoofieTimeseriesChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAnomalySoofieTimeseries.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchAnomalySoofieTimeseries.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchAnomalySoofieTimeseries.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default AnomalySoofieTimeseriesChartSlice;
